import { Box, Container, Flex, Spacer, Text, chakra } from "@chakra-ui/react";
import Navbar from "@/components/Navbar";
import { ParticlesContainer } from "@/utils/particles";
import PageInfo from "@/components/PageInfo";
import { LinkButton } from "@/components/shared/generic";
import { ChevronRightIcon } from "@chakra-ui/icons";
import CustomTypewriterEffect from "@/components/shared/CustomTypewriterEffect";
import fancyHeaderFont from "@/utils/style/gloock-font";
import OptimizedImage from "@/components/shared/OptimizedImage";
import { DATABASE_SIZE } from "@/utils/profile";

export default function AcceptanceRateCalculator() {
  // const collegeLimit = useBreakpointValue({ base: 5, md: 8 });
  return (
    <>
      <PageInfo
        title="Acceptance Rate Calculator"
        description={
          "Based on " + DATABASE_SIZE.applications + " real data points from Stanford, MIT, & more."
        }
        overrideOGImage="/images/acceptanceratecalculator/og.png"
        themeColor="#000000"
      />
      <Flex w="100vw" direction="column" h="100vh">
        <OptimizedImage
          layout="fill"
          objectFit="cover"
          priority
          filter="sepia(.5) saturate(2)"
          src="https://images.pexels.com/photos/207684/pexels-photo-207684.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          alt="Harvard University"
          zIndex={-1}
        />
        <Box
          zIndex={-1}
          pos="absolute"
          top={0}
          left={0}
          w="100%"
          h="100%"
          bg="linear-gradient(to top, #000000aa 0%, #00000066 60%, #000000aa 100%)"
        />
        <ParticlesContainer color="#ffffff" opacity={0.2} distance={200} />
        <Box flex={1}>
          <Navbar inverted />
        </Box>
        <Container maxW="container.md" color="white" textAlign="center">
          <chakra.h1
            className={fancyHeaderFont.className}
            fontSize={{ base: "5xl", md: "7xl" }}
            minH="3em"
          >
            Will I get into
            <CustomTypewriterEffect
              strings={[
                "Harvard?",
                "Stanford?",
                "MIT?",
                "Princeton?",
                "Yale?",
                "Duke?",
                "Columbia?",
                "Cornell?",
              ]}
              emojis={[]}
              typeSpeed={25}
              pauseDelay={2000}
              overallIterations={10}
            />
          </chakra.h1>
          <Text mt={4} fontSize={{ base: "2xl", md: "2xl" }}>
            Our AI uses {DATABASE_SIZE.applications} real data points to predict your odds.
          </Text>
          <LinkButton
            id="arc-cta"
            colorScheme="green"
            size="lg"
            rightIcon={<ChevronRightIcon />}
            href="/profile/acceptance-rate-calculator"
            mt={8}
          >
            Calculate my chances
          </LinkButton>
        </Container>
        <Spacer />
      </Flex>
    </>
  );
}
